import React, { memo } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function RetailPage() {
  return <div className="min-h-screen bg-white" data-id="element-907">
      {/* Header */}
      <div className="bg-gray-900 text-white py-20 md:py-32" data-id="element-908">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-909">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white mb-8 transition-colors" data-id="element-910">
            <ArrowLeftIcon size={16} data-id="element-911" />
            Back to Home
          </Link>
          <h1 className="text-4xl md:text-7xl font-light mb-6" data-id="element-912">
            Luxury Retail & Showrooms
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-light max-w-3xl" data-id="element-913">
            An experience guests remember. Premium hospitality for high-value
            clients.
          </p>
        </div>
      </div>

      {/* Hero Image */}
      <div className="relative h-[400px] md:h-[600px]" data-id="element-914">
        <img src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1600&q=80" alt="Luxury retail showroom" className="w-full h-full object-cover" data-id="element-915" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-916" />
      </div>

      {/* Value Propositions */}
      <div className="py-20 md:py-32" data-id="element-917">
        <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-918">
          <div className="max-w-4xl mx-auto space-y-20" data-id="element-919">
            {/* Value Prop 1 */}
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-920">
              <div data-id="element-921">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-922">
                  Impress High-Value Clients
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-923">
                  When clients are making significant purchasing decisions,
                  every detail matters. Premium water service shows you
                  understand luxury and attention to detail.
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-924">
                  <li className="flex items-start gap-3" data-id="element-925">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-926" />
                    <span data-id="element-927">Create a memorable first impression</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-928">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-929" />
                    <span data-id="element-930">Match your brand's premium positioning</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-931">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-932" />
                    <span data-id="element-933">Enhance the consultation experience</span>
                  </li>
                </ul>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-934">
                <img src="https://images.unsplash.com/photo-1555421689-491a97ff2040?w=800&q=80" alt="Luxury retail consultation" className="w-full h-full object-cover" data-id="element-935" />
              </div>
            </div>

            {/* Value Prop 2 */}
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-936">
              <div className="order-2 md:order-1 relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-937">
                <img src="https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=800&q=80" alt="High-end showroom" className="w-full h-full object-cover" data-id="element-938" />
              </div>
              <div className="order-1 md:order-2" data-id="element-939">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-940">
                  A Design Statement
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-941">
                  The WELLHAUS™ Drinkstation is more than functional—it's a
                  piece of design that complements your showroom's aesthetic and
                  reinforces your commitment to excellence.
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-942">
                  <li className="flex items-start gap-3" data-id="element-943">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-944" />
                    <span data-id="element-945">Complements luxury interiors</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-946">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-947" />
                    <span data-id="element-948">Conversation piece that impresses</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-949">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-950" />
                    <span data-id="element-951">Reinforces attention to detail</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Value Prop 3 */}
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-952">
              <div data-id="element-953">
                <h2 className="text-3xl md:text-5xl font-light mb-6" data-id="element-954">
                  Perfect for Extended Consultations
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-955">
                  Whether clients are browsing jewelry, selecting a vehicle, or
                  designing custom furniture, premium water service keeps them
                  comfortable during lengthy consultations.
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-956">
                  <li className="flex items-start gap-3" data-id="element-957">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-958" />
                    <span data-id="element-959">Still, sparkling, hot, and cold options</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-960">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-961" />
                    <span data-id="element-962">Always ready, no staff intervention needed</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-963">
                    <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-water-accent mt-2" data-id="element-964" />
                    <span data-id="element-965">Keeps clients comfortable and engaged</span>
                  </li>
                </ul>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-966">
                <img src="https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=800&q=80" alt="Luxury retail experience" className="w-full h-full object-cover" data-id="element-967" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gray-900 text-white py-20 md:py-32" data-id="element-968">
        <div className="container mx-auto px-4 md:px-6 lg:px-12 text-center" data-id="element-969">
          <h2 className="text-4xl md:text-6xl font-light mb-6" data-id="element-970">
            Elevate Your Client Experience
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-971">
            Join luxury brands that never compromise on hospitality and
            attention to detail.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-972">
            <a href="#demo" className="px-10 py-4 bg-white text-gray-900 text-base font-medium rounded-full hover:bg-gray-100 transition-colors" data-id="element-973">
              Request a Demo
            </a>
            <a href="#contact" className="px-10 py-4 border border-white text-white text-base font-medium rounded-full hover:bg-white hover:text-gray-900 transition-colors" data-id="element-974">
              Contact Sales
            </a>
          </div>
        </div>
      </div>
    </div>;
}